import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import TrolleyItemsPageComponents from 'apps/header/analytics/containers/TrolleyItemsPageComponents';
import MiniTrolleyItem from 'apps/header/containers/MiniTrolleyItem';
import { config } from 'api';
import { getPassiveHandlerDefaultOptions } from 'utils/detectPassiveEvents';

const MINI_TROLLEY_ITEM_SIZE_PX = 65;

export default class MiniTrolley extends PureComponent {
  static propTypes = {
    basket: PropTypes.shape({
      items: PropTypes.array.isRequired,
    }).isRequired,
    miniTrolley: PropTypes.object.isRequired,
    ensureBasketProducts: PropTypes.func.isRequired,
    setNewMiniTrolleyPosition: PropTypes.func.isRequired,
  };

  state = {
    isNextBtnDisabled: true,
    isPreviousBtnDisabled: true,
  };

  componentDidMount() {
    this.verifyTrolleyCapacity();

    this.mq = window.matchMedia(`(min-width: ${config.breakpoints.xlarge})`);
    this.mq.addListener(this.handleMediaQuery);
    this.handleMediaQuery(this.mq);
  }

  UNSAFE_componentWillUpdate() {
    this.props.ensureBasketProducts();
  }

  componentDidUpdate() {
    this.verifyTrolleyCapacity();
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.verifyTrolleyCapacity, getPassiveHandlerDefaultOptions());
  }

  handleMediaQuery = (mq) => {
    if (mq.matches) {
      window.addEventListener('resize', this.verifyTrolleyCapacity, getPassiveHandlerDefaultOptions());
    } else {
      window.removeEventListener('resize', this.verifyTrolleyCapacity, getPassiveHandlerDefaultOptions());
    }
  }

  verifyTrolleyCapacity = () => {
    if (!this.miniTrolleyContainer) {
      return;
    }

    const capacity = Math.ceil(this.miniTrolleyContainer.scrollWidth / MINI_TROLLEY_ITEM_SIZE_PX);

    const { length: basketSize } = this.props.basket.items;
    const { position } = this.props.miniTrolley;

    this.setState({
      isNextBtnDisabled: basketSize < position + capacity,
      isPreviousBtnDisabled: position <= 0,
    });
  };

  changeCurrentPosition = (change) => {
    this.props.setNewMiniTrolleyPosition(this.props.miniTrolley.position + change);
  };

  showNextItem = () => {
    this.changeCurrentPosition(1);
  };

  showPreviousItem = () => {
    this.changeCurrentPosition(-1);
  };

  render() {
    const { basket, miniTrolley } = this.props;
    const { isPreviousBtnDisabled, isNextBtnDisabled } = this.state;

    if (basket.numberOfItems <= 0 || basket.items.length <= 0) {
      return null;
    }

    const position = {
      marginLeft: -1 * miniTrolley.position * MINI_TROLLEY_ITEM_SIZE_PX,
    };

    return (
      <div className="hd-miniTrolley">
        <TrolleyItemsPageComponents items={basket.items} />

        <button
          disabled={isPreviousBtnDisabled}
          className="hd-miniTrolley__btnPrevious"
          onClick={this.showPreviousItem}
        >
          Previous
        </button>

        <div className="hd-miniTrolley__itemsContainer" ref={(ref) => { this.miniTrolleyContainer = ref; }}>
          <ol
            id="mini-trolley"
            className="hd-miniTrolley__items"
            style={position}
          >
            {basket.items.map((item) => (
              <MiniTrolleyItem
                key={item.sku}
                sku={item.sku}
              />
            ))}
          </ol>
        </div>

        <button
          disabled={isNextBtnDisabled}
          className="hd-miniTrolley__btnNext"
          onClick={this.showNextItem}
        >
          Next
        </button>
      </div>
    );
  }
}
